export default __webpack_public_path__ + "static/media/gallery_00.43cbc46e.jpg";